<template>
  <div>
    <el-card shadow="never">
      <div slot="header">
        <span class="title">基本信息</span>
      </div>
      <div style="width: 600px;">
        <el-form ref="ruleForm" :model="ruleForm" :rules="rules" label-width="100px">
          <el-form-item label="标签名称" prop="tagName">
            <el-input v-model="ruleForm.tagName" placeholder="请输入标签名称" />
          </el-form-item>
          <el-form-item label="标签类型" prop="tagType">
            <el-radio-group v-model="ruleForm['tagType']" disabled @change="tagChange">
              <el-radio label="0">数据标签</el-radio>
              <el-radio v-show="orgType==3" label="1">优先级标签</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item v-if="ruleForm.tagType==1" label="优先级" prop="priority">
            <el-input v-model="ruleForm.priority" placeholder="请输入优先级" disabled />
          </el-form-item>
          <el-form-item v-else label="移动端可见" prop="mobileVisible">
            <el-radio-group v-model="ruleForm.mobileVisible">
              <el-radio label="1">可见</el-radio>
              <el-radio label="0">不可见</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
    <el-card shadow="never">
      <div slot="header">
        <span class="title">数据选择</span>
      </div>
      <el-form ref="typeForm" :model="typeForm" :rules="typeRules" label-width="100px">
        <el-form-item v-if="ruleForm.tagType==0" label="数据类型" prop="dataType">
          <el-radio-group v-model="typeForm.dataType" disabled @change="$forceUpdate()">
            <el-radio v-show="orgType!=0" label="0">用户</el-radio>
            <el-radio v-show="orgType!=1&&orgType!=2" label="1">电站</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div class="border">
        <div style="margin: 10px;">
          <div>已选择</div>
          <template v-if="typeForm.dataType==='0'">
            <el-tag
              v-for="tag in tags"
              :key="tag.name"
              closable
              :type="tag.type"
              style="margin: 10px 10px 0 0"
              @close="closeTag(tag.id)"
            >
              {{ tag.name }}
            </el-tag>
          </template>
          <template v-else>
            <el-tag
              v-for="tag in tags1"
              :key="tag.name"
              closable
              :type="tag.type"
              style="margin: 10px 10px 0 0"
              @close="closeTag1(tag.id)"
            >
              {{ tag.name }}
            </el-tag>
          </template>
        </div>
      </div>
      <div class="border mt-25">
        <div style="margin: 10px;">
          <div class="pb-15">请选择{{ typeForm.dataType==='0'?'用户':'电站' }}</div>
          <STable v-if="typeForm.dataType==='0' " ref="tableref" :url="url" :columns="columns" :handles="{}" :query="query" :toolbar="toolbar" label-width="80px" />
          <STable v-else ref="tableref1" :url="url1" :columns="columns1" :handles="{}" :query="query1" :toolbar="toolbar1" label-width="80px" />
        </div>
      </div>
    </el-card>
    <div class="flexJCenter mt-25">
      <el-button @click="cancel">取消</el-button>
      <el-button type="primary" @click="onSubmit()">保存</el-button>
    </div>
  </div>
</template>

<script>
import { regionData } from 'element-china-area-data'
export default {
  data() {
    return {
      orgType: localStorage.getItem('orgType'), // 0 运营商；1 2 车辆机构 流量方；3 混合
      id: '',
      ruleForm: {
        tagName: '',
        tagType: '0',
        priority: '',
        mobileVisible: ''
      },
      rules: {
        tagName: [
          { required: true, message: '请输入标签名称', trigger: 'blur' }
        ],
        tagType: [
          { required: true, message: '请选择标签类型', trigger: 'change' }
        ],
        priority: [
          { required: true, message: '请输入优先级', trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              if (/^(?:[1-9]\d*)$/.test(value) === true || Number(value) === 0) {
                callback()
              } else {
                callback(new Error('请输入正整数'))
              }
            },
            trigger: 'blur'
          }
        ],
        mobileVisible: [
          { required: true, message: '请选择移动端是否可见', trigger: 'change' }
        ]
      },
      typeForm: {
        dataType: '0'
      },
      typeRules: {
        dataType: [
          { required: true, message: '请选择数据类型', trigger: 'change' }
        ]
      },
      tags: [],
      tags1: [],
      url: '/user/label/userList',
      url1: '/user/label/addOrUpdateStationList',
      query: [
        {
          label: '所属企业',
          prop: 'orgName',
          placeholder: '请输入企业名称'
        },
        {
          label: '用户账号',
          prop: 'loginName',
          placeholder: '请输入用户账号'
        },
        {
          label: '用户姓名',
          prop: 'username',
          placeholder: '请输入用户姓名'
        },
        {
          label: '用户类型',
          prop: 'type',
          placeholder: '请选择用户类型',
          type: 'select',
          data: [{
            label: '企业用户',
            value: 'true'
          }, {
            label: '非企业用户',
            value: 'false'
          }]
        },
        {
          label: '手机号',
          prop: 'mobile',
          placeholder: '请输入手机号'
        },
        {
          label: '车牌号',
          prop: 'carNumber',
          placeholder: '请输入车牌号'
        },
        {
          label: '用户状态',
          prop: 'status',
          placeholder: '请选择用户状态',
          type: 'select',
          data: [{
            label: '正常',
            value: 'false'
          }, {
            label: '冻结',
            value: 'true'
          }]
        },
        {
          label: '注册时间',
          prop: 'registerTime',
          placeholder: '',
          type: 'date2'
        }
      ],
      query1: [
        {
          label: '电站名称',
          prop: 'stationName',
          placeholder: '请输入电站名称'
        },
        {
          label: '归属运营商',
          prop: 'operatorName',
          placeholder: '请输入归属运营商'
        },
        {
          label: '区域',
          prop: 'cityName',
          placeholder: '请选择区域',
          data: regionData,
          props: { checkStrictly: true, value: 'value' },
          type: 'cascader'
        }
      ],
      columns1: [
        {
          label: '充电站名称',
          prop: 'stationName'
        },
        {
          label: '充电站地址',
          prop: 'address'
        },
        {
          label: '运营商',
          prop: 'operatorName'
        },
        {
          label: '区划',
          prop: 'areaCode'
        },
        {
          label: '充电次数',
          prop: 'chargeCount'
        },
        {
          label: '启停状态',
          prop: 'stationStatus',
          template: function(index, reocrd) {
            return reocrd.stationStatus === '启用' ? "<div class='circle green'></div><span>启用</span>" : "<div class='circle red'></div><span>停用</span>"
          }
        }
      ],
      columns: [
        {
          label: '所属企业',
          prop: 'orgName'
        },
        {
          label: '用户账号',
          prop: 'loginName'
        },
        {
          label: '用户姓名',
          prop: 'username'
        },
        {
          label: '车牌号',
          prop: 'carNumber'
        },
        {
          label: '用户类型',
          prop: 'type'
        },
        {
          label: '手机号',
          prop: 'mobile'
        },
        {
          label: '状态',
          prop: 'status'
        },
        {
          label: '注册时间',
          prop: 'registerTime'
        }
      ],
      toolbar: [
        {
          label: '添加',
          type: 'primary',
          before: res => {
            res.forEach(element => {
              const temp = {}
              temp.name = element.loginName
              temp.id = element.id
              if (this.tags.length < 1) {
                this.tags.push(temp)
              } else {
                const userIds = this.tags.map(value => value.id)
                if (!userIds.includes(element.id)) {
                  this.tags.push(temp)
                }
              }
            })
          }
        },
        {
          label: '移除',
          icon: 'el-icon-minus',
          before: res => {
            res.forEach(element => {
              this.tags.some((item, i) => {
                if (item.id === element.id) {
                  this.tags.splice(i, 1)
                  return true
                }
              })
            })
          }
        }
      ],
      toolbar1: [
        {
          label: '添加',
          type: 'primary',
          before: res => {
            res.forEach(element => {
              const temp = {}
              temp.name = element.stationName
              temp.id = element.id
              if (this.tags1.length < 1) {
                this.tags1.push(temp)
              } else {
                const stationIds = this.tags1.map(value => value.id)
                if (!stationIds.includes(element.id)) {
                  this.tags1.push(temp)
                }
              }
            })
          }
        },
        {
          label: '移除',
          icon: 'el-icon-minus',
          before: res => {
            res.forEach(element => {
              this.tags1.some((item, i) => {
                if (item.id === element.id) {
                  this.tags1.splice(i, 1)
                  return true
                }
              })
            })
          }
        }
      ]
    }
  },
  mounted() {
      let data = this.$route.query.data
      console.log(data,'dataaaaaaa')
      if(data==='[object Object]'){
     data = JSON.parse(decodeURIComponent(this.$route.query.data))
      }
      this.id = data.id
      this.ruleForm = {
        tagName: data.name,
        tagType: data.type,
        priority: data.priority,
        mobileVisible: data.visible
      }
      this.typeForm.dataType = data.dataType
            console.log(data,'dataType')
      console.log(this.typeForm.dataType,'dataType')
      if (data.dataType == '0') {
        // 选择的用户
        this.$store.dispatch('form/handle', {
          url: '/user/label/chooseObjects?labelId=' + data.id,
          callback: resp => {
            const temp = []
            resp.forEach(element => {
              const map = {}
              map.name = element.loginName
              map.id = element.userId
              temp.push(map)
            })
            this.tags = temp
          }
        })
      } else {
        // 选择的电站
        this.$store.dispatch('form/handle', {
          url: '/user/label/chooseObjects?labelId=' + data.id,
          callback: resp => {
            const temp = []
            resp.forEach(element => {
              const map = {}
              map.name = element.stationName
              map.id = element.stationId
              temp.push(map)
            })
            this.tags1 = temp
          }
        })
      }

  },
  methods: {
    tagChange(val) {
      if (val === '1') {
        this.typeForm.dataType = '1'
        this.tags = []
      }
    },
    closeTag(id) {
      const index = this.tags.findIndex(item => item.id === id)
      this.tags.splice(index, 1)
    },
    closeTag1(id) {
      const index = this.tags1.findIndex(item => item.id === id)
      this.tags1.splice(index, 1)
    },
    onSubmit() {
      let ruleFormBool = false
      this.$refs['ruleForm'].validate(valid => {
        ruleFormBool = valid
      })
      let typeFormBool = false
      this.$refs['typeForm'].validate(valid => {
        typeFormBool = valid
      })

      // 表单校验通过
	  let bindObjects = ''
      if (ruleFormBool && typeFormBool) {
        if (this.typeForm.dataType == 0) {
          bindObjects = this.tags.map((item, i) => item.id).join(',')
        } else {
          bindObjects = this.tags1.map((item, i) => item.id).join(',')
        }
        this.$store.dispatch('form/handle', {
          url: '/user/label',
          data: {
            'id': this.id,
            'name': this.ruleForm.tagName,
            'type': this.ruleForm.tagType,
            'priority': this.ruleForm.priority,
            'visible': this.ruleForm.mobileVisible,
            'dataType': this.typeForm.dataType,
            'bindObjects': bindObjects
          },
          method: 'post',
          callback: resp => {
            this.$router.go(-1)
          }
        })
      }
    },
    cancel() {
      this.$router.go(-1)
    }
  }
}
</script>

<style scoped lang="less">
  .border{
    width: 100%;
    border: 1px solid #EEEEEE;
  }
  .flexJCenter{
    display: flex;
    justify-content: center;
  }
  .mt-25{
    margin-top: 25px;
  }
  .pb-15{
    padding-bottom: 15px;
  }
</style>



// WEBPACK FOOTER //
// src/views/discount/modifyUserTag.vue